var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('span',[_vm._v("State Built "+_vm._s(_vm.year))]),_c('span',[_vm._v("Austin "),_c('icon-texas'),_vm._v(" Texas")],1),_c('span',[_vm._v("Web Builders")])])}
var staticRenderFns = []

export { render, staticRenderFns }